import React, { useEffect, useState } from 'react';
import './signin.css';
import logo from '../assets/logo.png';
import { PiPasswordBold } from "react-icons/pi";
import { IoMailOutline } from "react-icons/io5";
import { useFormik } from 'formik';
import * as Yup from "yup";
import { UserAuth } from '../context/context';
import { useNavigate, NavLink } from 'react-router-dom';
import { getDoc, doc } from "firebase/firestore";
import { db } from '../context/firebase';

const SignIn = () => {
  
  const { signIn, user, logout } = UserAuth();
  const navigate = useNavigate();
  
  // State for handling backend/auth errors and loading UI
  const [authError, setAuthError] = useState("");
  const [loading, setLoading] = useState(false);

  // 1. Navigation Guard: If user is already logged in, send them away from the sign-in page
  useEffect(() => {
  const checkUser = async () => {
    if (!user) return;

    const userRef = doc(db, "users", user.uid);
    const userSnap = await getDoc(userRef);

    if (userSnap.exists() && userSnap.data().disabled) {
      await logout();
      setAuthError("Account error, contact support.");
      return;
    }

    const isAdmin =
      user.email === "nnn@gmail.com" ||
      user.email === "hannaheaton124@gmail.com";

    navigate(isAdmin ? "/admin" : "/dashboard", { replace: true });
  };

  checkUser();
}, [user]);

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .required("Email is required")
        .email("Invalid email format"),
      password: Yup.string()
        .required("Password is required")
        .min(5, 'Password must be at least 5 characters'),
    }),
    onSubmit: async (values) => {
  setLoading(true);
  setAuthError("");

  try {
    const userCredential = await signIn(values.email, values.password);
    const uid = userCredential.user.uid;

    // 🔥 CHECK FIRESTORE FOR DISABLED USER
    const userRef = doc(db, "users", uid);
    const userSnap = await getDoc(userRef);

    if (userSnap.exists() && userSnap.data().disabled) {
      await logout(); // 🚨 immediately log them out
      setAuthError("Your account has been disabled. Contact support.");
      return;
    }

    // ✅ Only navigate if NOT disabled
    const isAdmin =
      values.email === "nnn@gmail.com" ||
      values.email === "hannaheaton124@gmail.com";

    navigate(isAdmin ? "/admin" : "/dashboard");

  } catch (e) {
    switch (e.code) {
      case 'auth/user-not-found':
      case 'auth/wrong-password':
      case 'auth/invalid-credential':
        setAuthError("Invalid email or password. Please try again.");
        break;
      case 'auth/network-request-failed':
        setAuthError("Network error. Check your connection.");
        break;
      case 'auth/too-many-requests':
        setAuthError("Too many attempts. Account temporarily locked.");
        break;
      default:
        setAuthError("Something went wrong. Please try again later.");
    }
  } finally {
    setLoading(false);
  }
},
  });

  return (
    <div className='signin'>
      <div className='signlogo'>
        <img className="h-62 w-226 imagelogo" src={logo} alt="ascentinvestments" />
        
        <div className='signform w-full'>
          <h1 className='nunito form-head'>User Login</h1>

          {/* 3. Global Auth Error Display */}
          {authError && (
            <div className="auth-error-box nunito" style={{color:'red'}}>
              {authError}
            </div>
          )}

          <form onSubmit={formik.handleSubmit}>
            <div>
              <p className='nunito input-header'>email <span style={{ color: 'red' }}>*</span></p>
              <span className='errors nunito'>
                {formik.touched.email && formik.errors.email ? formik.errors.email : ""}
              </span>
              <div  style={{ position: "relative" }} className={`input-with-icon ${formik.errors.email && formik.touched.email ? 'input-error' : ''}`}>
                <input
                 style={{
      paddingLeft: "40px", // space for the icon
      
    }}
                  type="email"
                  placeholder="mail@example.com"
                  name='email'
                  {...formik.getFieldProps('email')} // Shortens onChange, onBlur, value
                />
                
                <IoMailOutline color="#1a81c5" className="input-icon" />
              </div>
            </div>

            <div className='flex justify-between pado'>
              <p className='nunito input-header'>password <span style={{ color: 'red' }}>*</span></p>
              <p className='nunito input-header forgot'>
                <NavLink to="/forgottenPassword">forgot password?</NavLink>
              </p>
            </div>
            <p className='errors nunito'>
              {formik.touched.password && formik.errors.password ? formik.errors.password : ""}
            </p>
            <div className={`input-with-icon ${formik.errors.password && formik.touched.password ? 'input-error' : ''}`}>
              <input
                type="password"
                placeholder="Password"
                name='password'
                {...formik.getFieldProps('password')}
              />
              <PiPasswordBold color='#1a81c5' className="input-icon" />
            </div>

            {/* 4. Disable button while loading */}
            <button 
              type='submit' 
              className='nunito signinbut' 
              disabled={loading || !formik.isValid}
            >
              {loading ? "Signing in..." : "Sign in"}
            </button>
          </form>

          <p className='dont nunito'>
            Don't have an account? 
            <NavLink to="/register">
              <span style={{ fontWeight: 700, fontSize: "15px" }}> Sign Up </span>
            </NavLink>
          </p>
          <p className='copyright nunito'>© Copyright 2024 Ascent Investment Ltd. All Rights Reserved.</p>
        </div>
      </div>
    </div>
  );
};

export default SignIn;